export default class SummaryNav {
    constructor() {
        this.navBox = document.querySelectorAll('.summary-box')

        this.btnsCloseNav = document.querySelectorAll('.summary-box .close-modal')

        this.collapseNav()

        window.addEventListener('DOMContentLoaded', () => {
            const article = document.querySelector('.article-post')
            if (!article) return;

            const summaryBlocks = document.querySelectorAll('.summary-nav')
            if (!summaryBlocks.length) return;

            const tags = 'h2'

            // Create summary menu and relate each item to an id
            let htags = article.querySelectorAll(tags)

            
            if(htags.length < 2) {
                this.navBox.forEach((summaryBlock) => {
                    summaryBlock.style.display = "block";
                    summaryBlock.style.display = "none";
                })

            } else {

                htags.forEach(function (thisItem) {
                    if (thisItem.closest('.block-excerpt')) {
                        return
                    }
    
                    const title = thisItem.innerText.trim()
                    const id = slugify(title)
                    const htag = slugify(thisItem.tagName)
                    const link = `<li class="${htag}"> <a href="#${id}">${title}</a></li>`
    
                    thisItem.id = id

                    summaryBlocks.forEach((summaryBlock) => {
                        summaryBlock.insertAdjacentHTML('beforeend', link)
                    })
    
                })
    
                const observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            const id = entry.target.getAttribute('id')
                            let summaryNavs = document.querySelectorAll('.summary-nav')
                            let sumaryBox = document.querySelector('.summary-wrap')
                            
                            if (entry.isIntersecting) {
                                
                                summaryNavs.forEach((summaryNav) => { // Iterar sobre cada summaryNav
                                    // Remover 'active' de todos os 'li.active' dentro do summaryNav atual
                                    summaryNav.querySelectorAll('li.active').forEach((activeElement) => {
                                        activeElement.classList.remove('active');
                                    });
                
                                    // Adicionar 'active' ao parent de `li a[href="#${id}"]` dentro do summaryNav atual
                                    summaryNav.querySelectorAll(`li a[href="#${id}"]`).forEach((link) => {
                                        link.parentElement.classList.add('active');
                                    });
                
                                    // Ajuste necessário: Remover o console.log ou ajustá-lo para lidar com múltiplos elementos
                                    // console.log(summaryNav.querySelector(`li a[href="#${id}"]`).parentElement); // Isso pode não ser mais relevante, pois estamos lidando com múltiplos elementos.
                
                                    // Ajustar o scroll para o primeiro item ativo dentro do summaryNav atual
                                    setTimeout(() => {
                                        let firstItemActive = summaryNav.querySelectorAll('li.active');
                                        if (firstItemActive.length > 0) { // Verificar se há elementos ativos
                                            let scrollTo = firstItemActive[0].offsetTop; // Usar o primeiro item ativo para o scroll
                
                                            summaryNav.scroll({
                                                top: scrollTo - 10,
                                                behavior: 'smooth',
                                            });
                                        }
                                    }, 300);
                                });
                            }
                        })
                    },
                    { rootMargin: '-60px' }
                )
    
                // Create hierarchical sections for all titles and their subordinate content
                const splitTags = tags.split(',')
    
                splitTags.forEach((tagName) => {
                    const elementTag = article.querySelectorAll(tagName)
    
                    elementTag.forEach((tag) => {
                        let sectionWrap = document.createElement('section')
                        sectionWrap.setAttribute('data-id', tag.id)
                        sectionWrap.setAttribute('class', 'wrap-section')
                        sectionWrap.dataset.type = tagName
    
                        let subordinateElements = nextUntil(tag, tagName)
                        subordinateElements.forEach((subEl) => {
                            sectionWrap.insertAdjacentElement('beforeend', subEl)
                        })
    
                        // add observer
                        observer.observe(tag)
    
                        tag.insertAdjacentElement('beforebegin', sectionWrap)
                        sectionWrap.insertAdjacentElement('afterbegin', tag)
                    })
                })
            }
        })

        if (window.innerWidth < 700) {
            this.navBox.forEach((summaryBlock) => {
                summaryBlock.classList.add('collapse');
            });
            document.addEventListener('click', (event) => {
                // Se o clique não foi dentro de nenhum navBox
                const clickedOutside = ![...this.navBox].some(nav => nav.contains(event.target));
          
                if (clickedOutside) {
                  this.navBox.forEach((summaryBlock) => {
                    if (!summaryBlock.classList.contains('collapse')) {
                      summaryBlock.classList.add('collapse');
                    }
                  });
                }
            });
        }else {
            this.navBox.forEach((summaryBlock) => {
                summaryBlock.classList.remove('collapse');
            });
        }
    }

    collapseNav() {
        this.btnsCloseNav.forEach((btnCloseNav) => {
            btnCloseNav.addEventListener('click', () => {
                this.navBox.forEach((summaryBlock) => {
                    summaryBlock.classList.toggle('collapse')

                })
            })
        })
    }
    
}
new SummaryNav();

let slugify = function (str) {
    return str
        .toString()
        .normalize('NFKD')
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-]+/g, '')
        .replace(/\-\-+/g, '-')
}

let nextUntil = function (elem, selector, filter) {
    let siblings = []
    elem = elem.nextElementSibling

    while (elem) {
        if (elem.matches(selector)) break

        if (filter && !elem.matches(filter)) {
            elem = elem.nextElementSibling
            continue
        }

        siblings.push(elem)

        elem = elem.nextElementSibling
    }

    return siblings
}
